"use client";
import React from "react";
import { useTranslation } from "react-i18next";

import {
  PreviewLinks,
  PreviewPdf,
  PreviewUrl,
  PreviewApps,
  PreviewImages,
  PreviewVideo,
  PreviewWifi,
  PreviewYoutube,
  PreviewWebsite,
  PreviewBusiness,
  PreviewVcard,
  PreviewSocial,
  PreviewEvent,
  PreviewCoupon,
  PreviewFeedback,
  PreviewMp3,
  PreviewText,
  PreviewEmail,
  PreviewUrlStatic,
  PreviewSMS,
  PreviewWhatsapp,
} from "@/components/previews";

import { QRViewPageTemplateProps } from "./types";
import { LocaleDataFetcher } from "@/services/LocaleDataFetcher/LocaleDataFetcher";
import { getSiteDomain } from "@/utils/site";
import { PAGES } from "@/data/types/pages";

import "./styles.scss";

export const QRViewPageTemplate = ({ qrData, language }: QRViewPageTemplateProps) => {
  const qrType = qrData?.type || "";

  const [previewTranslations, setPreviewTranslations] = React.useState(undefined);

  const { t } = useTranslation(qrType);

  const domainFolder = getSiteDomain();

  const qrFormDataBusness = require(`@/data/domain/${domainFolder}/content-types/business`).default;
  const qrFormDataVcard = require(`@/data/domain/${domainFolder}/content-types/vcard`).default;
  const qrFormDataEvent = require(`@/data/domain/${domainFolder}/content-types/event`).default;

  const previews = {
    website: PreviewWebsite,
    listoflinks: PreviewLinks,
    pdf: PreviewPdf,
    url: PreviewUrl,
    apps: PreviewApps,
    business: PreviewBusiness,
    image: PreviewImages,
    video: PreviewVideo,
    wifi: PreviewWifi,
    youtube: PreviewYoutube,
    vcard: PreviewVcard,
    social: PreviewSocial,
    event: PreviewEvent,
    coupon: PreviewCoupon,
    feedback: PreviewFeedback,
    mp3: PreviewMp3,
    text: PreviewText,
    email: PreviewEmail,
    ["url-static"]: PreviewUrlStatic,
    sms: PreviewSMS,
    whatsapp: PreviewWhatsapp,
  };

  React.useEffect(() => {
    if (qrData?.type) {
      const dataFetcherInstance = new LocaleDataFetcher({
        page: PAGES.QR_VIEW,
        language,
      });
      let pageData;
      switch (qrData?.type) {
        case "business":
          pageData = dataFetcherInstance.getTranslations(
            t,
            qrFormDataBusness.layoutTranslations
          ) as any;
          break;
        case "vcard":
          pageData = dataFetcherInstance.getTranslations(
            t,
            qrFormDataVcard.layoutTranslations
          ) as any;
          break;
        case "event":
          pageData = dataFetcherInstance.getTranslations(
            t,
            qrFormDataEvent.layoutTranslations
          ) as any;
          break;

        default:
          break;
      }

      setPreviewTranslations(pageData);
    }
  }, [qrData]);

  const Empty = () => <div></div>;
  const Component = previews[qrType] || Empty;
  const preview = !(
    qrType === "url" ||
    qrType === "wifi" ||
    qrType === "image" ||
    qrType === "text" ||
    qrType === "whatsapp"
  );

  return (
    <div className="QRCodePage">
      <Component
        {...qrData}
        previewTranslations={previewTranslations}
        preview={preview}
        source={"preview-page"}
      />
    </div>
  );
};
